import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=884eb258&scoped=true"
import script from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=884eb258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884eb258",
  null
  
)

export default component.exports